import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as config from '../config.json'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.prototype.$secureCookies = config.secureCookies
Vue.prototype.$secureApi = config.secureApi
Vue.prototype.$hostApi = config.hostApi
Vue.prototype.$centralApi = config.centralApi
Vue.prototype.$domain = config.domain
Vue.prototype.$customerPort = config.customerPort

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
